import { ResourceLinkWrap } from '@components/ResourceLink/ResourceLink.style';
import styled from 'styled-components';
import { Items } from '../Resources/Resources.styles';

export { Container, Head, Line, Row } from '../Resources/Resources.styles';

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1b203a;
  width: 100%;
`;

export const CounterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
`;

export const Counter = styled.div`
  display: flex;
  height: 22px;
  background-color: #edeff4;
  border-radius: 4px;
  padding: 0px 6px;

  font-size: 14px;
  font-weight: 600;
  color: #474d66;
`;

export const DItems = styled(Items)`
  & ${ResourceLinkWrap} {
    --base-height: 52px;
    --i-padding-block: 6px;
  }
`;
